<template>
  <!--begin::Ot Listing-->
  <div class="ot-template">
    <PageHeaderCount
      moduleType="ot"
      :dataLoading="dataLoading"
      :statusList="statusList"
      allkey="all_ots"
      countkey="ot_status_count"
    ></PageHeaderCount>
    <ListingTemplate
      :customClass="'ot-listing'"
      v-if="getPermission('ot:view')"
    >
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-flex class="pt-0 mxw-200 my-auto">
                <h1 class="form-title d-flex margin-auto selected-rows-text">
                  {{ totalSelected }} Selected
                </h1>
              </v-flex>
              <v-flex class="pt-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('ot:update')">
                  <v-menu
                    content-class="custom-menu-list"
                    bottom
                    offset-y
                    transition="slide-y-transition"
                    :close-on-click="true"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="dataLoading"
                        depressed
                        class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(more, index) in otMoreAction">
                        <v-list-item
                          link
                          v-on:click="updateMoreAction(more.action)"
                          :key="index"
                        >
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              more.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            class="font-weight-500 font-size-14"
                            >{{ more.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  :disabled="dataLoading"
                  depressed
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-flex>
            </template>
            <template v-else>
              <v-flex class="pt-0 mxw-200">
                <h1 class="form-title d-flex margin-auto">
                  <v-select
                    :disabled="dataLoading"
                    :items="statusList"
                    v-model="status"
                    hide-details
                    item-color="cyan"
                    class="pt-0 mt-0 listing-status main-listing-status-filter"
                    item-text="text"
                    item-value="value"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip
                          :color="item.color"
                          :text-color="item.textcolor"
                        >
                          <template v-if="item.value == 'all'">{{
                            item.all_ots
                          }}</template>
                          <template v-else>{{ item.ot_status_count }}</template>
                        </v-chip>
                      </v-list-item-action>
                    </template>
                  </v-select>
                </h1>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex
                class="pt-0 justify-flex-end d-flex margin-auto all-project-btn-right"
              >
                <v-autocomplete
                  v-if="is_main_super_admin > 0"
                  class="mr-2"
                  hide-details
                  clearable
                  style="max-width: 250px !important"
                  v-model.trim="filter_engineer"
                  :items="engineerList"
                  :search-input.sync="engineerSearch"
                  @keyup.enter="doEngineerSearch"
                  :filter="() => true"
                  dense
                  flat
                  filled
                  placeholder="Technician"
                  item-color="cyan"
                  color="cyan"
                  solo
                  :loading="engineerLoading"
                  :disabled="engineerLoading"
                  item-text="display_name"
                  item-value="id"
                  v-on:change="getRows()"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title
                        v-html="'No Technician(s) Found.'"
                      ></v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar
                      height="30"
                      min-width="30"
                      width="30"
                      class="mr-1 my-1 grey lighten-2 grey--text"
                    >
                      <v-img
                        v-if="item?.profile_logo?.file?.url"
                        :src="item.profile_logo.file.url"
                      ></v-img>
                      <span v-else class="fw-600 mb-1">
                        {{ item.display_name.slice(0, 2).toUpperCase() }}
                      </span>
                    </v-list-item-avatar>
                    <v-list-item-content class="text-ellipsis max-width-400px">
                      <v-list-item-title
                        class="text-capitalize font-weight-500 font-size-16"
                        >{{ item.display_name }}
                      </v-list-item-title>
                      <v-list-item-title
                        class="text-capitalize font-weight-500 font-size-16"
                      >
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              v-if="item?.entity_relation?.name"
                              small
                              label
                              color="blue"
                              outlined
                              text-color=""
                              >{{ item.entity_relation.name }}
                            </v-chip>
                          </template>
                          <span>Entity Name</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action
                      class="align-self-center"
                      v-if="filter_engineer == item.id"
                    >
                      <v-icon color="cyan">mdi-check</v-icon>
                    </v-list-item-action>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-if="is_main_super_admin > 0 && false"
                  hide-details
                  clearable
                  style="max-width: 250px !important"
                  v-model="filter_visit"
                  :items="visitList"
                  :search-input.sync="visitSearch"
                  @keyup.enter="doVisitSearch"
                  :filter="() => true"
                  dense
                  flat
                  filled
                  placeholder="Visit"
                  item-color="cyan"
                  color="cyan"
                  solo
                  :loading="visitLoading"
                  :disabled="visitLoading"
                  item-text="title"
                  item-value="id"
                  v-on:change="getRows()"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title
                        v-html="'No Visit(s) Found.'"
                      ></v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content class="text-ellipsis max-width-400px">
                      <v-list-item-title
                        class="text-capitalize font-weight-500 font-size-16"
                      >
                        {{ item.barcode }} :- {{ item.title }}
                      </v-list-item-title>
                      <v-list-item-title
                        class="text-capitalize font-weight-500 font-size-16"
                      >
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              v-if="item?.entity_relation?.name"
                              small
                              label
                              color="blue"
                              outlined
                              text-color=""
                              >{{ item.entity_relation.name }}
                            </v-chip>
                          </template>
                          <span>Entity Name</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action
                      class="align-self-center"
                      v-if="filter_visit == item.id"
                    >
                      <v-icon color="cyan">mdi-check</v-icon>
                    </v-list-item-action>
                  </template>
                </v-autocomplete>
                <template v-if="getPermission('ot:create') && false">
                  <v-btn
                    :disabled="dataLoading"
                    depressed
                    class="mx-2 custom-bold-button custom-btn-color white--text"
                    :to="getDefaultRoute('ot.create')"
                  >
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-btn
                  v-if="false"
                  :disabled="dataLoading"
                  depressed
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>

                <v-menu content-class="custom-menu-list" offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="dataLoading"
                      depressed
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-on:click="exportOt"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark left>mdi-database-export</v-icon> Export
                    </v-btn>
                    <v-btn
                      :disabled="dataLoading"
                      depressed
                      class="mx-2 custom-bold-button"
                      v-on:click="importDialog = true"
                      color="cyan white--text"
                      v-if="false"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark left>mdi-database-import</v-icon> Import
                    </v-btn>
                  </template>
                </v-menu>
                <v-menu
                  max-height="400"
                  max-width="250"
                  offset-y
                  left
                  :close-on-content-click="false"
                  content-class="white-background"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="dataLoading"
                      depressed
                      class="mx-2 custom-bold-button btn-tab-hide"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                    v-on:change="updateVisible()"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          color="cyan"
                          hide-details
                          class="mt-0 mb-0"
                          v-on:change="updateVisible()"
                        ></v-checkbox>
                        <v-icon class="draggable-drag-icon" right color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
                <entity-dropdown
                  v-if="is_main_super_admin > 0"
                  :entity="entity"
                  :entityList="entityList"
                  :loading="dataLoading"
                  @change="updateEntity"
                />
              </v-flex>
            </template>
          </template>
        </ListingHeader>
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="Ot"
          :basicSearchFields="['entity', 'visit_id', 'Technicians id']"
          :allowedSearchFields="searchableArray"
        ></ListingSearchCriteria>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="cols.visible"
                      :key="cols.id"
                      class="simple-table-th"
                      :class="{
                        'checkbox-width-limit': cols.checkbox,
                        'pointer-events-none': lodash.isEmpty(rowData),
                      }"
                    >
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          :disabled="dataLoading"
                          v-model="selectedAll"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else>
                        <div
                          v-if="cols.sortable"
                          class="simple-table-text sortable"
                          v-on:click="
                            !dataLoading
                              ? updateSorting({
                                  field: cols.field,
                                  sort: cols.sort,
                                })
                              : 'javascript:void(0)'
                          "
                        >
                          {{ cols.headerName }}
                        </div>
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                        <template v-if="cols.sort">
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'asc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-ascending</v-icon
                          >
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'desc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-descending</v-icon
                          >
                        </template>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="!lodash.isEmpty(rowData)">
                  <tr
                    class="customer-listing-row"
                    v-for="(data, index) in rowData"
                    :key="index"
                    link
                  >
                    <template v-for="cols in customThead">
                      <td
                        v-if="cols.visible"
                        :key="cols.id"
                        :class="{
                          'simple-table-td': !cols.checkbox,
                          'checkbox-width-limit': cols.checkbox,
                        }"
                        v-on:click="
                          Number(cols.checkbox) == 0
                            ? rowClicked(data)
                            : 'javascript:void(0)'
                        "
                      >
                        <template
                          v-if="cols.checkbox && Number(cols.checkbox) == 1"
                        >
                          <v-checkbox
                            dense
                            :disabled="[2, 3].includes(data.status)"
                            v-model="selectedRows"
                            v-bind:value="data.id"
                            color="cyan"
                            class="hide-margin"
                            hide-details
                          ></v-checkbox>
                        </template>
                        <template v-else-if="cols.field == 'barcode'">
                          <Barcode
                            route="ot.detail"
                            :id="data.id"
                            :barcode="data.barcode"
                          ></Barcode>
                        </template>
                        <template v-else-if="cols.field == 'entity'">
                          <div
                            class="customer-listing-customer font-weight-700"
                            v-if="data?.entity?.name"
                          >
                            <p class="m-0 custom-nowrap-ellipsis">
                              {{ data?.entity?.name }}
                            </p>
                          </div>
                          <em class="text-muted" v-else> no entity </em>
                        </template>
                        <template v-else-if="cols.field == 'engineer'">
                          <template v-if="data?.engineer?.barcode">
                            <v-chip
                              small
                              class="text-white p-3 cursor-pointer mt-1 engineer-chip"
                              color="cyan"
                              label
                              outlined
                              @click.prevent.stop="
                                routeToDetailLink(
                                  data.engineer.id,
                                  'admin.engineer.detail'
                                )
                              "
                            >
                              {{ data.engineer.barcode }}
                            </v-chip>
                          </template>

                          <em class="text-muted" v-else> no engineer </em>
                        </template>

                        <template v-else-if="cols.field == 'start_date'">
                          <div class="customer-listing-customer">
                            <p class="m-0 custom-nowrap-ellipsis">
                              {{ formatDate(data.start_date) }}
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'reason'">
                          <div
                            class="customer-listing-customer font-weight-700"
                            v-if="data?.reason"
                          >
                            <p class="m-0 custom-nowrap-ellipsis">
                              {{ data?.reason }}
                            </p>
                          </div>
                          <em class="text-muted" v-else> no reason </em>
                        </template>
                        <template v-else-if="cols.field == 'status'">
                          <div class="user-listing-user">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                  v-bind="attrs"
                                  v-on="on"
                                  :color="getColor(data.status)"
                                  label
                                  v-if="data.status"
                                  small
                                  style="height: 22px"
                                  :text-color="data?.enq_status_textcolor"
                                  class="ml-2 text-uppercase font-weight-600"
                                >
                                  <span class="font-size-16 font-weight-500">
                                    {{ getStatus(data.status) }}
                                  </span>
                                </v-chip>
                              </template>

                              <span> Status </span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'start_time'">
                          <div
                            class="m-0 max-content-width text-truncate"
                            v-if="data?.start_time"
                          >
                            <p class="m-0 mb-1">
                              <span
                                class="m-0 text-truncate"
                                content=" Start Date"
                                v-tippy="{
                                  arrow: true,
                                  arrowType: 'round',
                                  animation: 'fade',
                                }"
                              >
                                <b class="mr-2"> Start Time&nbsp;: </b>
                                <template v-if="data && data?.start_time">
                                  <v-chip
                                    small
                                    outlined
                                    color="red"
                                    label
                                    class="mr-2"
                                  >
                                    {{ formatDateStartTime(data?.start_time) }}
                                  </v-chip>
                                </template>
                                <template v-else>
                                  <em class="text-muted"> no started at</em>
                                </template>
                              </span>
                            </p>
                            <p class="m-0 mb-1">
                              <span
                                class="m-0 text-truncate"
                                content=" End Date"
                                v-tippy="{
                                  arrow: true,
                                  arrowType: 'round',
                                  animation: 'fade',
                                }"
                              >
                                <b class="mr-2"> End Time &nbsp;&nbsp;: </b>
                                <template v-if="data && data?.end_time">
                                  <v-chip
                                    small
                                    outlined
                                    color="green"
                                    label
                                    class="mr-2"
                                  >
                                    {{ formatDateStartTime(data?.end_time) }}
                                  </v-chip>
                                </template>
                                <template v-else>
                                  <em class="text-muted"> no ended at</em>
                                </template>
                              </span>
                            </p>
                          </div>
                          <em v-else class="text-muted"> no time</em>
                        </template>
                        <template v-else-if="cols.field == 'visit'">
                          <template v-if="data?.visit?.barcode">
                            <v-chip
                              small
                              class="text-white p-3 cursor-pointer mt-1 visit-chip"
                              color="orange"
                              label
                              outlined
                              @click.prevent.stop="
                                routeToDetailLink(
                                  data.visit.id,
                                  'admin.visit.detail'
                                )
                              "
                            >
                              {{ data.visit.barcode }}
                            </v-chip>
                          </template>

                          <em class="text-muted" v-else> no visit </em>
                        </template>

                        <template v-else-if="cols.field == 'added_at'">
                          <TableActivity
                            v-if="!lodash.isEmpty(data.added_by)"
                            :data="data"
                          >
                            <template v-slot:display_name>
                              {{ data.added_by.display_name }}
                            </template>
                            <template v-slot:date_time>
                              {{ data.created_at }}
                            </template>
                            <template v-slot:format_date_time>
                              {{ formatDateTime(data.added_at) }}
                            </template>
                          </TableActivity>
                        </template>
                        <template v-else-if="cols.field == 'updated_at'">
                          <TableActivity
                            v-if="!lodash.isEmpty(data.updated_by)"
                            :data="data"
                          >
                            <template v-slot:display_name>
                              {{ data.updated_by.display_name }}
                            </template>
                            <template v-slot:date_time>
                              {{ data.modified_at }}
                            </template>
                            <template v-slot:format_date_time>
                              {{ formatDateTime(data.updated_at) }}
                            </template>
                          </TableActivity>
                        </template>
                        <template v-else>
                          <div v-html="printRowData(cols, data)"></div>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                <tr v-else-if="!dataLoading">
                  <td colspan="14" class="py-4">
                    <p
                      class="m-0 row-not-found text-center font-weight-500 font-size-16"
                    >
                      <img
                        :src="$assetURL('media/error/empty.png')"
                        class="row-not-found-image"
                      />
                      Uhh... There are no ot at the moment.
                    </p>
                  </td>
                </tr>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>
      </template>
    </ListingTemplate>
    <Dialog :commonDialog="bulkDialog" :dialog-width="dialogWidth">
      <template v-slot:title>
        {{ bulkStatus == 2 ? "Accept Remark" : "Reject Remark" }}
      </template>
      <template v-slot:body>
        <v-form ref="bulkForm" v-model.trim="formValid" lazy-validation>
          <!-- Confirmation Message -->
          <p class="font-weight-600 text-h6 mb-4">
            Are you sure you want to
            <b>{{ bulkStatus == 2 ? "accept" : "reject" }}</b>
            remark(s) for barcode
            <span class="font-weight-700">
              {{ selectedOtBarcodes.join(", ") }}
            </span>
            ?
          </p>
          <!-- Remark Field -->
          <div class="remark-field">
            <label class="font-weight-600 text-h6 mb-2 d-block">
              Remark
              <span v-if="bulkStatus == 3" class="red--text">*</span>
            </label>
            <TextAreaField
              :rules="getRemarkRules()"
              v-model="bulkRemark"
              auto-grow
              dense
              filled
              color="cyan"
              :placeholder="
                bulkStatus == 2
                  ? 'Enter accepted remark'
                  : 'Enter rejected remark'
              "
              solo
              flat
              row-height="25"
              counter="200"
              class="remark-textarea"
            />
          </div>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          depressed
          @click="bulkDialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :color="isDisabled ? '' : 'cyan'"
          :class="['mx-2 custom-bold-button', { 'white--text': !isDisabled }]"
          depressed
          :disabled="isDisabled"
          @click="confirmBulkUpdate"
        >
          Submit
        </v-btn>
      </template>
    </Dialog>
  </div>
  <!--end::Ot Listing-->
</template>

<script>
import moment from "moment-timezone";
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { QUERY, PATCH, DOWNLOAD } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import JwtService from "@/core/services/jwt.service";
import { saveAs } from "file-saver";
import Dialog from "@/view/pages/partials/Dialog";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [CommonMixin, ListingMixin],
  name: "ot-list",

  data() {
    return {
      filter_visit: null,
      exportLoading: false,
      pageModule: "ot-listing",
      routeAPI: "ot",
      routeName: "ot",
      routeDetailName: "ot.detail",
      status: "all",
      // file: "",
      importDialog: false,
      statusList: [],
      customThead: [],
      engineerList: [],
      engineerSearch: "",
      engineerLoading: false,
      engineerTimeout: null,
      TimeoutLimit: 1000,
      visitList: [],
      visitSearch: "",
      visitLoading: false,
      visitTimeout: null,
      bulkDialog: false,
      bulkStatus: null,
      bulkRemark: "",
      entity: this.reEntityId,
      // moreActions: [
      //   {
      //     title: "Refresh List",
      //     action: "refresh_list",
      //     divider: true,
      //     icon: "mdi-refresh",
      //   },
      // ],
      otMoreAction: [
        {
          title: "Mark as Accepted",
          action: "mark_as_accepted",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Rejected",
          action: "mark_as_rejected",
          icon: "mdi-check-all",
        },
      ],
    };
  },
  watch: {
    engineerSearch() {
      this.doEngineerTypingSearch();
    },
    filter_engineer(val) {
      const selected = this.engineerList.find((e) => e.id === val);
      if (selected) {
        this.engineerSearch = selected.display_name;
        this.getEngineerList();
        this.getRows();
      }
    },
    visitSearch() {
      this.doVisitTypingSearch();
    },

    filter_visit(val) {
      const selected = this.visitList.find((v) => v.id === val);
      if (selected) {
        this.visitSearch = selected.title;
        this.getVisitList();
        this.getRows();
      }
    },
    "$route.query.status"(param) {
      this.status = param;
    },
  },
  components: {
    draggable,
    PageHeaderCount,
    Barcode,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
  },

  methods: {
    doEngineerTypingSearch() {
      clearTimeout(this.engineerTimeout);
      this.engineerTimeout = setTimeout(() => {
        this.doEngineerSearch();
      }, this.TimeoutLimit);
    },
    doEngineerSearch() {
      const param = this.engineerSearch || "";
      if (param.length < 2) {
        this.engineerLoading = false;
        return;
      }
      const selectedEngineer = this.engineerList.find(
        (row) => row.id === this.filter_engineer
      );
      if (selectedEngineer?.id && selectedEngineer.display_name === param) {
        this.engineerLoading = false;
        return;
      }
      this.getEngineerList(param);
    },
    doVisitTypingSearch() {
      clearTimeout(this.visitTimeout);
      this.visitTimeout = setTimeout(() => {
        this.doVisitSearch();
      }, this.TimeoutLimit);
    },

    doVisitSearch() {
      const param = this.visitSearch || "";
      if (param.length < 2) {
        this.visitLoading = false;
        return;
      }
      const selected = this.visitList.find(
        (row) => row.id === this.filter_visit
      );
      if (selected?.id && selected.title === param) {
        this.visitLoading = false;
        return;
      }
      this.getVisitList(param);
    },
    updateMoreAction(action) {
      if (action === "mark_as_accepted") {
        this.openBulkDialog(2);
      }
      if (action === "mark_as_rejected") {
        this.openBulkDialog(3);
      }
    },
    openBulkDialog(status) {
      this.bulkStatus = status;
      this.bulkRemark = "";
      this.bulkDialog = true;
    },
    confirmBulkUpdate() {
      if (this.bulkStatus === 3 && !this.bulkRemark?.trim()) {
        this.$toast.error("Remark is required");
        return;
      }
      const payload = {
        ot: this.selectedRows,
        status: this.bulkStatus,
      };
      if (this.bulkStatus === 2) {
        payload.accepted_remark = this.bulkRemark;
      }
      if (this.bulkStatus === 3) {
        payload.rejected_remark = this.bulkRemark;
      }
      this.$store
        .dispatch(PATCH, {
          url: "ot/status",
          data: payload,
        })
        .then(() => {
          this.bulkDialog = false;
          this.getRows();
        })
        .catch(this.logError)
        .finally(() => {
          this.dataLoading = false;
        });
    },
    formatDateStartTime(row) {
      return moment(row).format("hh:mm A");
    },
    getStatus(status) {
      if (status == 1) {
        return "Pending";
      } else if (status == 2) {
        return "Accepted";
      } else if (status == 3) {
        return "Rejected";
      }
    },
    getColor(status) {
      if (status == 1) {
        return "orange white--text";
      } else if (status == 2) {
        return "green white--text";
      } else if (status == 3) {
        return "red white--text";
      }
    },
    updateOtStatus(status) {
      const _this = this;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "ot/status",
          data: { ot: _this.selectedRows, status },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          _this.importDialog = true;
          break;
        case "export_items":
          _this.bulkOtExport();
          break;
        case "export_current_view":
          _this.exportCurrentView("ot");
          break;
        case "refresh_list":
          _this.getRows();
          break;
      }
    },
    getRemarkRules() {
      if (this.confirm_type === "mark_as_rejected") {
        return [this.validateRules.required(this.actionData.remark, "Remark")];
      }
      return [];
    },
    exportOt() {
      let downloadURL = process.env.VUE_APP_API_URL + "ot/export";
      downloadURL = new URL(downloadURL);
      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);
      if (this.entity && this.entity.id) {
        this.queryParams.entity = Number(this.entity.id);
      } else {
        delete this.queryParams.entity;
      }
      this.lodash.map(this.queryParams, function (row, index) {
        downloadURL.searchParams.append(index, row);
      });

      this.lodash.map(this.listingSearch, function (row, index) {
        if (index == "dates") {
          if (row && row[0]) {
            downloadURL.searchParams.append("dates[0]", row[0]);
          }
          if (row && row[1]) {
            downloadURL.searchParams.append("dates[1]", row[1]);
          }
        } else {
          downloadURL.searchParams.append(index, row);
        }
      });
      downloadURL.searchParams.append(
        "filter_engineer",
        this.filter_engineer ? this.filter_engineer : ""
      );
      downloadURL.searchParams.append(
        "filter_visit",
        this.filter_visit ? this.filter_visit : ""
      );
      // console.log({ downloadURL });
      window.open(downloadURL, "_blank");
    },
    bulkCustomerExport() {
      const _this = this;
      let fileName = new Date();
      _this.exportLoading = true;
      _this.$store
        .dispatch(DOWNLOAD, {
          url: "ot/export",
        })
        .then(({ data }) => {
          saveAs(data, "ot-export-" + fileName.getTime() + ".xlsx");
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.exportLoading = false;
        });
    },
    getEngineerList(search = "") {
      this.engineerLoading = true;
      // this.engineerList = [];

      this.$store
        .dispatch(QUERY, {
          url: "engineer-list",
          data: {
            entity: this.reEntityId,
            search: search,
            isListFilter: 1,
            value: this.filter_engineer,
          },
        })
        .then(({ data }) => {
          this.engineerList = data || [];
        })
        .catch(this.logError)
        .finally(() => {
          this.engineerLoading = false;
        });
    },

    getVisitList(search = "") {
      this.visitLoading = true;

      this.$store
        .dispatch(QUERY, {
          url: "visit-list",
          data: {
            entity: this.reEntityId,
            search: search,
            isListFilter: 1,
            value: this.filter_visit,
          },
        })
        .then(({ data }) => {
          this.visitList = data || [];
        })
        .catch(this.logError)
        .finally(() => {
          this.visitLoading = false;
        });
    },
  },
  computed: {
    dialogWidth() {
      // return 400;
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 40);
    },
    selectedOtBarcodes() {
      return this.rowData
        .filter((item) => this.selectedRows.includes(item.id))
        .map((item) => item.barcode);
    },
    isDisabled() {
      return (
        this.dataLoading || (this.bulkStatus === 3 && !this.bulkRemark?.trim())
      );
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Ot",
      },
    ]);
    this.getEngineerList();
    this.getVisitList();
    this.getRows();
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    _this.status = _this.$route.query.status || _this.status;

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
